<template>
<div class="loading-panel">
  <div class="loading">
      <pulse-loader color="#20a8d8"></pulse-loader>
  </div>
</div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'LoadingPanel',
  components: {
    PulseLoader
  }
}
</script>
<style type="text/css">
  .loading-panel{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 88888;
    background: rgba(255,255,255, 0.7);
  }
  .loading {
    position: absolute;
    left: 48%;
    top: 48%;
  }
</style>
